import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import { formatDate } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoDeadLine extends Component {

    render() {
        const { to_date } = this.props;
        return (
            <CodeInfoSection title='Срок действия' staticText={`Действует до ${formatDate(to_date)}`} />
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoDeadLine.js